import React, { useState } from "react";
import "./QuickView.css";
import { useCurrency } from "../../Context/CurrencyContext";

const QuickView = ({ open, onClose }) => {
  const { formatPrice } = useCurrency();
  const [qty, setQty] = useState(1);
  const [size, setSize] = useState("15ml");
  const [product] = useState({
    id: 1,
    brand: "MOKOSH",
    title: "Figa smoothing face cream",
    price: 650,
    priceValue: 650,
    image: "https://wonder-theme-beauty.myshopify.com/cdn/shop/products/mokosh_eb6f0013-4fcc-4f5e-8693-7200be74e429.jpg?v=1661021258&width=1000"
  });

  if (!open) return null;

  return (
    <>
      <div className="quickview-overlay" onClick={onClose}></div>

      <div className="quickview">
        <button className="close-btn" onClick={onClose}>✕</button>

        <img
          className="card_img"
          src={product.image}
          alt={product.title}
        />

        <p className="brand">{product.brand}</p>
        <h2 className="title">{product.title}</h2>
        <p className="price">{formatPrice(product.price)}</p>
        <p className="tax">Tax included.</p>

        <div className="chips">
          <span>Jojoba</span>
          <span>Argan Oil</span>
        </div>

        <p className="label">Size: <b>{size}</b></p>

        <div className="chips">
          <span className={size === "15ml" ? "active" : ""} onClick={() => setSize("15ml")}>15ml</span>
          <span className={size === "60ml" ? "active" : ""} onClick={() => setSize("60ml")}>60ml</span>
        </div>

        <div className="qty-wrapper">
          <button className="qty-btn" onClick={() => setQty(qty > 1 ? qty - 1 : 1)}>
            <svg viewBox="0 0 72 72"><line x1="16" y1="36" x2="56" y2="36" /></svg>
          </button>

          <input className="qty-input" value={qty} readOnly />

          <button className="qty-btn" onClick={() => setQty(qty + 1)}>
            <svg viewBox="0 0 72 72">
              <line x1="36" y1="16" x2="36" y2="56" />
              <line x1="16" y1="36" x2="56" y2="36" />
            </svg>
          </button>
        </div>

        <button className="add-cart">ADD TO CART</button>
        <a className="details" href="#">View all details</a>
      </div>
    </>
  );
};

export default QuickView;